import { Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { ZIndexLevels } from "../../risk/geoUtils";

export const PRETTY_BLUE = "#1976d2";
export const MUTED_GREEN = "#c3cdc7";

export const ADVISORY_COLOR = "#dadada";

type BorderProps = {
    label: React.ReactNode | string,
    children: React.ReactNode,
    errorProp: { error: boolean, helperText?: undefined },
    rows?: number,
    topOffset?: number,
    toolTipText?: string,
    backgroundColor: string,
    overrideIsSelected: boolean, // this is an override for selecting waypoints on the map - because clicking on a map causes
    // this input's toBlur function called, but the input box is still "active" in the sense that we can populate it via
    // map clicks, we want to be able to still show the input box as highlighted.  This field provides an override for
    // highlighting
};

export const BorderWithLabel = ( {
    label,
    children,
    errorProp,
    rows,
    topOffset,
    toolTipText,
    overrideIsSelected,
    backgroundColor
}: BorderProps ) =>
{
    const [ hover, setHover ] = React.useState( false );
    const [ focus, setFocus ] = React.useState( false );
    const lightGrey = "#b0b0b0";
    const red = "rgb(211, 47, 47)";
    const height = 56 * ( rows ?? 1 ) + "px";
    const topPosition = ( topOffset ?? 0 ) + "px";

    const isSelected = focus || overrideIsSelected;
    const borderLabel = (
        <label data-shrink = "true" htmlFor = ":r2h:" id = ":r2h:-label">
            <Box
                sx = {{
                    position: "relative",
                    display: "inline-block",
                    fontSize: "13px",
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 400,
                    top: "-13px",
                    left: "8px",
                    background: backgroundColor,
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    color: errorProp.error ? red : isSelected ? PRETTY_BLUE : "grey",
                    zIndex: ZIndexLevels.UIElement,
                }}
            >
                {label}
            </Box>
        </label>
    );
    return (
        <Box>
            <div
                style = {{
                    height: height,
                    border:
            ( isSelected ? "2" : "1" ) +
            "px solid " +
            ( errorProp.error
                ? red
                : isSelected
                    ? PRETTY_BLUE
                    : hover
                        ? "black"
                        : lightGrey ),
                    borderRadius: "1px",
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px",
                }}
            >
                {toolTipText !== undefined ? (
                    <Tooltip title = {toolTipText}>{borderLabel}</Tooltip>
                ) : (
                    ( borderLabel )
                )}
                <div
                    style = {{
                        position: "relative",
                        top: topPosition,
                        paddingTop: "0px",
                        paddingBottom: "0px",
                    }}
                    onMouseEnter = {() => setHover( true )}
                    onMouseLeave = {() => setHover( false )}
                    onFocus = {() => setFocus( true )}
                    onBlur = {() => setFocus( false )}
                >
                    {children}
                </div>
            </div>

            {errorProp.error && (
                <p
                    style = {{
                        color: red,
                        fontSize: "13px",
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                        margin: 0,
                        marginLeft: "13px",
                    }}
                    /*className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1wc848c-MuiFormHelperText-root"*/
                    id = ":r23:-helper-text"
                >
                    {errorProp.helperText}
                </p>
            )}
        </Box>
    );
};
